// MyGet.shell namespace
(function (myget, ns, $, ko) {
    // Knockout binding extensions
    ko.bindingHandlers.textOr = {
        update: function (element, valueAccessor, allBindingsAccessor) {
            var value = ko.utils.unwrapObservable(valueAccessor());
            var text = ko.utils.unwrapObservable(value['text']);
            if (value['modifier'] && text) {
                text = value['modifier'](text);
            }

            ko.bindingHandlers.text.update(element, function () { return text ? text : ko.utils.unwrapObservable(value['or']); });
        }
    };
    
    ko.bindingHandlers.clipboard = {
        init: function (element, valueAccessor, allBindingsAccessor) {
            var value = ko.utils.unwrapObservable(valueAccessor());

            var $element = $(element);
            $element.data('clipboard-text', value);
            $element.click(function (e) {
                myget.copyToClipboard($(this).data('clipboard-text'), $(this).get(0));
            });
        },
        update: function (element, valueAccessor, allBindingsAccessor) {
            var value = ko.utils.unwrapObservable(valueAccessor());
            $(element).data('clipboard-text', value);
        }
    };

    ko.bindingHandlers.focusOnType = {
        init: function (element, valueAccessor) {
            var value = ko.utils.unwrapObservable(valueAccessor());
            if (!value) return;

            var $element = $(element);

            $(document).on('keydown', function (e) {
                var code = (e.keyCode || e.which);
                var isValidInputCharacter =
                    ((code >= 48 && code <= 57)           // numbers 0-9
                            || (code >= 64 && code <= 90)     // letters a-z
                            || (code >= 96 && code <= 111)    // numpad
                            || (code >= 186 && code <= 192)   // ; = , - . / `
                            || (code >= 219 && code <= 222))  // [\ ] '
                        && !e.altKey && !e.ctrlKey && !e.metaKey;

                if (isValidInputCharacter && document.activeElement == document.body) {
                    $element.focus();
                    var currInput = $element.val();
                    $element.val("");
                    $element.val(currInput);
                }
            });
        },
        update: function () { }
    };

    ko.bindingHandlers.datetimepicker = {
        init: function (element, valueAccessor, allBindingsAccessor) {
            var value = ko.utils.unwrapObservable(valueAccessor());

            var options = ko.utils.unwrapObservable(allBindingsAccessor().datetimepickerOptions) || {
                format: 'yyyy-mm-dd HH:ii P',
                showMeridian: true,
                autoclose: true,
                todayBtn: false,
                startDate: new Date(),
                initialDate: ''
            };

            if (value) {
                if (value.indexOf('/Date(') >= 0) {
                    $(element).datetimepicker('update', moment(value).toDate());
                } else {
                    $(element).datetimepicker('update', moment(value, 'YYYY-MM-DDTHH:mm:ss.SSSZ').toDate());
                }
            }

            $(element).datetimepicker(options).on('changeDate', function (e) {
                var observable = valueAccessor();
                var mo = moment(e.date);
                observable(mo.format('YYYY-MM-DDTHH:mm:ss.SSSZ'));
            });

            if (!options.initialDate) {
                $(element).datetimepicker('update', '');
            }

            $(element).keydown(function (e) {
                e.preventDefault();

                return false;
            });
        },
        update: function (element, valueAccessor) {
            var value = ko.utils.unwrapObservable(valueAccessor());

            if (value && value.indexOf('9999') < 0 && value.indexOf('/Date(') >= 0) {
                $(element).datetimepicker('update', moment(value).toDate());
            } else if (value && value.indexOf('9999') < 0) {
                $(element).datetimepicker('update', moment(value, 'YYYY-MM-DDTHH:mm:ss.SSSZ').toDate());
            } else {
                $(element).val('');
                $(element).datetimepicker('update');
            }
        }
    };

    ko.bindingHandlers.multiselect = {
        init: function (element, valueAccessor, allBindingsAccessor) {
            var options = ko.unwrap(valueAccessor());
            $(element).multiselect(options);
        },
    };

    ko.bindingHandlers.numericText = {
        update: function (element, valueAccessor, allBindingsAccessor) {
            var value = ko.utils.unwrapObservable(valueAccessor()),
            precision = ko.utils.unwrapObservable(allBindingsAccessor().precision) || ko.bindingHandlers.numericText.defaultPrecision,
            formattedValue = Math.round(value, precision).toLocaleString();

            ko.bindingHandlers.text.update(element, function () { return formattedValue; });
        },
        defaultPrecision: 2
    };
    
    ko.bindingHandlers.moment = {
        update: function (element, valueAccessor, allBindingsAccessor) {
            var value = ko.utils.unwrapObservable(valueAccessor());
            var momentFormat = ko.utils.unwrapObservable(allBindingsAccessor().momentFormat);

            if (value.indexOf('+') < 0 && value.indexOf('Z') < 0) {
                value += 'Z';
            }

            ko.bindingHandlers.text.update(element, function () {
                var mo = moment(value);
                if (!momentFormat) {
                    return mo.from(moment.utc());
                } else {
                    return mo.format(momentFormat);
                }
            });
        }
    };

    ko.bindingHandlers.bytesText = {
        update: function (element, valueAccessor, allBindingsAccessor) {
            var value = ko.utils.unwrapObservable(valueAccessor()),
                precision = ko.utils.unwrapObservable(allBindingsAccessor().precision) || ko.bindingHandlers.numericText.defaultPrecision,
                formattedValue = value;

            var sizes = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];
            if (value == 'NaN' || value == null || value == undefined) {
                formattedValue = "unlimited";
            } else if (value == 0) {
                formattedValue = '0 bytes';
            } else {
                var i = parseInt(Math.floor(Math.log(value) / Math.log(1024)));
                formattedValue = Math.round(value / Math.pow(1024, i), precision) + ' ' + sizes[i];
            }

            ko.bindingHandlers.text.update(element, function () { return formattedValue; });
        },
        defaultPrecision: 2
    };
    
    ko.bindingHandlers.widget = {
        update: function (element, valueAccessor, allBindingsAccessor, viewModel) {
            var widgetBindings = _getWidgetBindings(element, valueAccessor, allBindingsAccessor, viewModel);

            // Attach the jQuery UI Widget and/or update its options.
            // (The syntax is the same for both.)
            $(element)[widgetBindings.widgetName](widgetBindings.widgetOptions);
            for (key in widgetBindings.widgetOptions) {
                if (key.indexOf('on') == 0) {
                    $(element).on(key.substr(2), widgetBindings.widgetOptions[key]);
                } else if (key == 'subscribe') {
                    widgetBindings.widgetOptions[key]($(element));
                }
            }
        }
    };

    ko.bindingHandlers.reveal = {
        init: function (element, valueAccessor, allBindingsAccessor) {
            var value = ko.utils.unwrapObservable(valueAccessor());

            myget.reveal($(element), value, '<hidden - click to show>');
        },
        update: function (element, valueAccessor, allBindingsAccessor) {
            var value = ko.utils.unwrapObservable(valueAccessor());
            $(element).data('reveal', value);
        }
    };
    
    ko.bindingHandlers.myget = {
        update: function (element, valueAccessor, allBindingsAccessor, viewModel) {
            var widgetBindings = _getWidgetBindings(element, valueAccessor, allBindingsAccessor, viewModel);

            // Attach the myget Widget and/or update its options.
            // (The syntax is the same for both.)
            $(element)[widgetBindings.widgetName](widgetBindings.widgetOptions);
        }
    };

    function _getWidgetBindings(element, valueAccessor, allBindingsAccessor, viewModel) {
        // Extract widgetName and widgetOptions from the data binding,
        // with some sanity checking and error reporting.
        // Returns dict: widgetName, widgetOptions.

        var value = valueAccessor(),
            myBinding = ko.utils.unwrapObservable(value),
            allBindings = allBindingsAccessor();

        if (typeof(myBinding) === 'string') {
            // Short-form data-bind='jqueryui: "widget_name"'
            // with no additional options
            myBinding = { 'widget': myBinding };
        }

        var widgetName = myBinding.widget,
            widgetOptions = myBinding.options; // ok if undefined

        // Sanity check: can't directly check that it's truly a _widget_, but
        // can at least verify that it's a defined function on jQuery:
        if (typeof $.fn[widgetName] !== 'function') {
            throw new Error("jqueryui binding doesn't recognize '" + widgetName + "' as jQuery UI widget");
        }

        // Sanity check: don't confuse KO's 'options' binding with jqueryui binding's 'options' property
        if (allBindings.options && !widgetOptions && element.tagName !== 'SELECT') {
            throw new Error("jqueryui binding options should be specified like this:\n  data-bind='jqueryui: {widget:\"" + widgetName + "\", options:{...} }'");
        }

        // Value?
        if (allBindings.value) {
            widgetOptions.value = allBindings.value();
        }

        return {
            widgetName: widgetName,
            widgetOptions: widgetOptions
        };
    }


    // Classes
    ns.menuItem = function (url, title, active, identifier) {
        this.url = url;
        this.title = ko.observable(title);
        this.active = ko.observable(active);
        this.identifier = identifier || url;
    };

    ns.pagedViewModel = function (data, onUpdate, matchQuery, filters) {
        var $self = this;

        this.onUpdate = onUpdate || function () { };
        this.matchQuery = matchQuery || function (item, queryString) {
            for (var property in item) {
                if (item.hasOwnProperty(property)) {
                    var unwrappedProperty = ko.utils.unwrapObservable(item[property]);
                    if (unwrappedProperty && (typeof unwrappedProperty == 'string') && unwrappedProperty.toLowerCase().indexOf(queryString) != -1) {
                        return true;
                    } else if (unwrappedProperty && (typeof unwrappedProperty == 'object') && ko.toJSON(item).toLowerCase().indexOf(queryString) != -1) {
                        return true;
                    }
                }
            }
            return false;
        };
        this.filters = filters || [{ title: 'all', matchFilter: function (item) { return true; } }];

        this.activeFilter = ko.observable(this.filters[0]);
        this.setActiveFilter = function (selectedFilter) {
            $self.activeFilter(selectedFilter);
        };
        
        this.data = data;
        
        this.queryString = ko.observable("");
        this.filteredData = ko.computed(function () {
            var queryString = $self.queryString().toLowerCase();

            return $.grep($self.data(), function(item) {
                var matches = true;
                if ($self.activeFilter()) {
                    matches = matches && $self.activeFilter().matchFilter(item);
                }
                if (queryString !== '') {
                    matches = matches && $self.matchQuery(item, queryString);
                }
                return matches;
            });
        });
        this.filteredCount = ko.computed(function () {
            return $self.filteredData().length;
        });
        
        this.page = ko.observable(1);
        this.pageSize = ko.observable(25);
        this.pageCount = ko.computed(function () {
            return $self.filteredData().length > 0 ? Math.ceil($self.filteredData().length / $self.pageSize()) : 1;
        });
        this.pageData = ko.computed(function () {
            var result = [];
            for (var i = ($self.page() - 1) * $self.pageSize() ; i < $self.page() * $self.pageSize() && i < $self.filteredData().length; i++) {
                result.push($self.filteredData()[i]);
            }

            setTimeout($self.onUpdate, 10);
            return result;
        });
        this.pageNumbers = ko.computed(function () {
            return ko.utils.range(1, $self.pageCount());
        });
        this.hasData = ko.computed(function () {
            return $self.data().length > 0;
        });
    };

    ns.notificationsViewModel = function () {
        var $self = this;
        
        this.messages = ko.observableArray();

        // Behaviours
        this.notification = function (message, messageType) {
            if (!messageType) {
                messageType = 'info';
            }

            $self.messages.push({ message: message, messageType: messageType });
            window.setTimeout(function () { $self.messages.shift(); }, 6000);
        };
    };

    ns.shellViewModel = function (items) {
        var $self = this;
        var _defaultMenuItemFallback = new ns.menuItem('', '', '', '');

        // Data
        this.menuItems = ko.observableArray(items);

        this.defaultMenuItem = function () {
            if ($self.menuItems().length == 0)
            {
                return _defaultMenuItemFallback;
            }
            
            var defaultItem = $self.menuItems()[0];

            $.each($self.menuItems(), function (i, item) {
                if (item.active()) {
                    defaultItem = item;
                }
            });

            return defaultItem;
        };

        this.activeView = ko.observable('blank-template');
        this.activeViewModel = ko.observable({});

        this.title = ko.observable($self.defaultMenuItem().title());
        this.messages = ko.observableArray();

        // Behaviours
        this.notification = function (message, messageType) {
            if (!messageType) {
                messageType = 'info';
            }
            
            $self.messages.push({ message: message, messageType: messageType });
            window.setTimeout(function () { $self.messages.shift(); }, 6000);
        };

        this.wireValidation = function (elements) {
            if ($ && $.validator && $.validator.unobtrusive && elements && elements.length > 0) {
                var $form = $(elements[0]).find('form');

                $form.unbind();
                $form.data("validator", null);
                $.validator.unobtrusive.parse(document);
            }
        };

        this.activateMenuItem = function (identifier) {
            $.each($self.menuItems(), function (i, item) {
                item.active(item.identifier == identifier);

                if (item.identifier == identifier) {
                    myget.shell.model.title(item.title());
                }
            });
        };

        this.activateView = function(viewName, viewModel) {
            $self.activeView('blank-template');
            $self.activeViewModel(viewModel);
            $self.activeView(viewName);
        };
    };

    // Global notifications view model (wired) to avoid "multiple bindings" errors.
    // Should also make binding much faster.
    var notificationsModel;
    ns.notifications = function (existingModelWithNotifications) {
        if (!notificationsModel && !existingModelWithNotifications) {
            notificationsModel = new myget.shell.notificationsViewModel();
            ko.applyBindings(notificationsModel, $('#notifications-messages').get(0));
        } else if (existingModelWithNotifications) {
            return existingModelWithNotifications;
        }
        return notificationsModel;
    };

    // Data
    ns.model = null;

    // Behaviours
    ns.initialize = function (items) {
        $(document).ajaxStart(function () {
            $('#ajaxActivity').show();
        }).ajaxStop(function () {
            $('#ajaxActivity').hide();
        }).ajaxError(function (e, jqXHR, ajaxSettings, thrownError) {
            if (jqXHR.status == "401") {
                window.location.replace('/account/login');
            }
        });

        ns.model = new ns.shellViewModel(items);
        ko.applyBindings(ns.model);
    };

} (window.myget = window.myget || {}, window.myget.shell = window.myget.shell || {}, jQuery, ko));